import React, { useRef } from "react";
import { Card, Carousel, Typography } from "antd";
const { Title } = Typography;

interface Holiday {
  name: string;
  date: string;
}

interface HolidaysCarouselProps {
  holidays: Holiday[];
}

const HolidaysCarousel: React.FC<HolidaysCarouselProps> = ({ holidays }) => {
  const carouselRef = useRef<any>(null);

  const handlePrev = () => {
    carouselRef.current?.prev();
  };

  const handleNext = () => {
    carouselRef.current?.next();
  };

  return (
    <Card bordered={false}    >
      <Title level={5}>{'Holidays'}</Title>
      <Carousel arrows dotPosition="right">
        {holidays.map((holiday, index) => (
          <div key={index} >
            <strong style={{ fontSize: "18px" }}>{holiday.name}</strong>
            <p style={{ margin: 0 }}>{holiday.date}</p>
          </div>
        ))}
      </Carousel>
    </Card>
  );
};

export default HolidaysCarousel;
